import { CompetitionsPrioritiesWidget } from '@/components/sports/CompetitionsPriorities';
import Vue from 'vue';

export default Vue.extend({
  name: 'CompetitionsPriorities',
  render() {
    return <CompetitionsPrioritiesWidget />;
  },
});
